import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // 1. Check for manual user preference first
    const saved = localStorage.getItem('user_language_preference');
    if (saved === 'pt' || saved === 'en') return saved;

    // 2. Detect browser language
    const primaryLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();

    // If it's Portuguese (pt, pt-BR, pt-PT), return 'pt'. Otherwise English.
    return primaryLang.startsWith('pt') ? 'pt' : 'en';
  });

  const toggleLanguage = () => {
    setLanguage(prev => {
      const newLang = prev === 'pt' ? 'en' : 'pt';
      // Persist manual choice
      localStorage.setItem('user_language_preference', newLang);
      return newLang;
    });
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};






